import { Box, TextField, Typography } from "@mui/material";
import { countryFormatter } from "../../../../shared/utils";
import { useClientDetails } from "../../context/clientDetailsContext";

function AddressFields() {
  const {
    client: { details },
  } = useClientDetails();
  if (!details?.address) throw new Error("Address is required");

  return (
    <>
      <Typography sx={{ paddingBottom: 4 }} align="left" variant="h6">
        Address
      </Typography>
      <TextField
        sx={{ paddingBottom: 2 }}
        value={details.address.street}
        id="client-address-street"
        label="Street"
        size="small"
      />
      <Box
        data-testid="city-zipcode-container"
        sx={{
          display: "flex",
          direction: "row",
          justifyContent: "space-between",
        }}
      >
        <TextField
          sx={{ paddingBottom: 2, width: "48%" }}
          value={details.address.city}
          id="client-address-city"
          label="City"
          size="small"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        <TextField
          sx={{ paddingBottom: 2, width: "48%" }}
          value={details.address.zipCode}
          id="client-address-zipCode"
          label="Post Code"
          size="small"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
      </Box>
      <TextField
        sx={{ paddingBottom: 2 }}
        value={countryFormatter(details.address.country)?.name || ""}
        id="client-address-country"
        label="Country"
        size="small"
        slotProps={{
          input: {
            readOnly: true,
          },
        }}
      />
    </>
  );
}

export default AddressFields;
